// 외부 링크(노션 약관·정책, 공지사항, 고객센터 구글 폼). 서버 app_settings.links 를 폐지하고 클라 상수로 옮겼다(AC0-230).
// 바꾸려면 이 파일만 고치고 배포(OTA 번들 포함)한다.
import { publicWebUrl } from "./publicUrl";

export const LINKS = {
  /** 이용약관 */
  terms: "https://slash-move-a2b.notion.site/3fee664d4f40819f87fbffc561934049",
  /** 개인정보처리방침 */
  privacy: "https://slash-move-a2b.notion.site/3fee664d4f4081c7880ff8aa56d2712b",
  /** 운영정책 */
  operationPolicy: "https://slash-move-a2b.notion.site/3fee664d4f4081c38cc4e869e3734b89",
  /** 청소년 보호정책 */
  youthPolicy: "https://slash-move-a2b.notion.site/3fee664d4f40810ba820d70f486da6df",
  /** 환불정책 */
  refundPolicy: "https://slash-move-a2b.notion.site/3fee664d4f408111910ad50a2fef03ea",
  /** 공지사항 */
  notice: "https://slash-move-a2b.notion.site/407e664d4f408158b4efc84e6f6e2b46",
  /** 고객센터 문의(구글 폼). 프리필 entry 는 SUPPORT_PREFILL_ENTRIES */
  supportForm: "https://docs.google.com/forms/d/e/1FAIpQLSdiL9f3xXvehbQz6ucaJQZF1Gh45hjK2N-p2t20wioqVPzNmQ/viewform",
} as const;

export type LinkKey = keyof typeof LINKS;
/** 그대로 여는 문서 링크(약관·정책·공지). 고객센터 폼은 프리필을 붙여 연다 */
export type DocLinkKey = Exclude<LinkKey, "supportForm">;

/**
 * 약관 동의 화면(F01-03) 선택·안내 행의 상세 안내(노션). 시안은 모든 행에 chevron 이지만 페이지가 아직 없다.
 * URL 이 null 이면 그 행은 chevron 없이 그린다 — 노션 페이지가 생기면 여기만 채운다.
 */
export const CONSENT_DETAIL_LINKS: Record<"ai" | "marketing" | "nightMarketing", string | null> = {
  /** AI 생성 콘텐츠 이용 안내 (노션 "AI 생성 콘텐츠 및 대화 데이터 처리 안내") */
  ai: "https://slash-move-a2b.notion.site/408e664d4f4081a08354c6d59a9035be",
  /** 마케팅 정보 수신 안내 */
  marketing: null,
  /** 야간 혜택 알림 수신 안내 */
  nightMarketing: null,
};

/**
 * 익명 의견 페이지(AC0-315). 회원 정보는 넘기지 않고 들어온 위치만 `from` 으로 붙인다.
 * 화면은 우리 도메인 정적 페이지(public/feedback.html)이고 Apps Script 는 그 안에서 fetch 로만 부른다(AC0-320) —
 * Apps Script 를 Custom Tab 으로 직접 열면 Google 계정이 여럿 로그인된 기기에서 /macros/u/N/ 404 가 난다.
 */
export type FeedbackFrom = "home" | "plot" | "chat_list";

export const feedbackUrl = (from: FeedbackFrom): string => publicWebUrl(`/feedback.html?from=${from}`);

/** 고객센터 폼 프리필 entry ID. 주문번호는 사용자가 폼에서 직접 입력(프리필 없음) */
export const SUPPORT_PREFILL_ENTRIES = {
  /** 회원번호 */
  userId: "1059789318",
  /** "기기 · OS · 앱 버전" 한 줄 */
  deviceInfo: "2116176440",
} as const;
